import { llmModelDropdownOptions } from '@/libs/features/llm/display'
import { DevToolOptions } from './types'

/**
 * Parses a numeric input's text back to DevToolOptions' number type,
 * treating an empty field as "unset" (falls back to the API's own default)
 * @param value
 */
function parseNumberInput(value: string): number | undefined {
  return value === '' ? undefined : Number(value)
}

/**
 *
 * @param props
 * @param props.modelValue
 * @param props.loading
 */
export function setup(props: { modelValue: DevToolOptions; loading: boolean }) {
  /**
   * @param value
   */
  function setTemperature(value: string) {
    props.modelValue.temperature = parseNumberInput(value)
  }

  /**
   * @param value
   */
  function setMaxResponseTokens(value: string) {
    props.modelValue.maxResponseTokens = parseNumberInput(value)
  }

  return {
    llmModelDropdownOptions,
    setTemperature,
    setMaxResponseTokens,
  }
}
